import addClass from '../../../general/class/addClass';
import removeClass from '../../../general/class/removeClass';
import setAttr from '../../../general/attr/setAttr';

import * as exElement from '../../../utils/element';

import type { Context } from '../types';

import inSingle from './single';
import inMultiple from './multiple';

// ----------------------------------------------------------------------------

function option(ctx: Context): any {
    ctx.shared.state.options = [];

    ctx.single = inSingle(ctx);
    ctx.multiple = inMultiple(ctx);

    // ------------------------------------------------------------------------

    function start(): void {
        // If using type multi
        if (ctx.shared.config.type === 'multi') {
            ctx.multiple.start();
        }
        // If using type single
        else {
            ctx.single.start();
        }
    }

    // ------------------------------------------------------------------------

    function createItem(element: HTMLOptionElement): HTMLElement {
        // Create element (link)
        const elLink = exElement.create({
            tag: 'a',
            class: {
                new: 'dropdown-item',
            },
            attr: {
                value: element.value,
            },
            html: element.text,
        });

        // --------------------------------------------------------------------

        // If there is disabled
        if (element.disabled) {
            setAttr(elLink, 'disabled', '');
        }

        // If there is selected
        if (element.selected) {
            addClass(elLink, 'selected active');
        }

        // --------------------------------------------------------------------

        return elLink;
    }

    // ------------------------------------------------------------------------

    function getOptions(): Record<string, any>[] {
        return ctx.shared.state.options;
    }

    function reset(): void {
        // Foreach Options
        for (const item of getOptions()) {
            removeClass(item.element, 'selected active');
        }
    }

    function clear(): void {
        ctx.shared.state.options = [];
    }

    // ------------------------------------------------------------------------

    return {
        start,
        createItem,
        getOptions,
        reset,
        clear,
    };
}

// ----------------------------------------------------------------------------

export default option;
